import { faLock } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString } from "et3-type-guards";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreLoginStore from "../../stores/core/core-login-store";
import LoginTextField from "./LoginTextField";

const PasswordFormItem = withLiteObserverAndTheme(() => {
  const store = getCoreLoginStore();
  const disabledEnter = store.isSignInDisabled.get();
  const hasError = isDefinedString(i18n.get(store.errorKey.get()));

  return (
    <LoginTextField
      icon={faLock}
      type={"password"}
      label={i18n.get("PASSWORD")}
      hint={""}
      value={store.password.get()}
      hasError={hasError}
      onChoose={(value: string) => getCoreLoginStore().setPassword(value)}
      onEnter={() => {
        if (!disabledEnter) {
          getCoreLoginStore().signIn();
        }
      }}
    />
  );
});
export default PasswordFormItem;
